export default function MediaSection() {
  const getMediaImage = (index: number) => {
    const images = [
      'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20editorial%20image%20for%20an%20investigative%20report%20about%20entertainment%20scandal%2C%20warm%20orange%20and%20dark%20tones%2C%20play%20button%20overlay%20feel%2C%20dramatic%20lighting%2C%20news%20report%20aesthetic&width=800&height=500&seq=media-video-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20editorial%20image%20for%20consumer%20rights%20expose%2C%20warm%20amber%20and%20cream%20tones%2C%20documentary%20style%2C%20clean%20composition%2C%20investigative%20journalism%20vibe&width=800&height=500&seq=media-video-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20editorial%20image%20for%20tech%20industry%20secrets%20revealed%2C%20warm%20coral%20and%20dark%20tones%2C%20futuristic%20elements%2C%20dramatic%20lighting%2C%20tech%20report%20style&width=800&height=500&seq=media-video-03&orientation=landscape',
      'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20editorial%20image%20for%20food%20safety%20investigation%2C%20warm%20orange%20and%20beige%20tones%2C%20clean%20minimalist%20style%2C%20consumer%20report%20aesthetic&width=800&height=500&seq=media-video-04&orientation=landscape',
      'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20editorial%20image%20for%20workplace%20culture%20expose%2C%20warm%20terracotta%20and%20cream%20tones%2C%20office%20elements%2C%20minimalist%20design%2C%20modern%20report%20style&width=800&height=500&seq=media-video-05&orientation=landscape',
    ];
    return images[index];
  };

  const MEDIA_ITEMS = [
    { title: '独家揭秘：某顶流艺人合同纠纷全纪录', duration: '15:28', views: '12.3万', tag: '独家' },
    { title: '暗访实录：外卖平台商家卫生状况触目惊心', duration: '08:45', views: '9.7万', tag: '暗访' },
    { title: '深度分析：科技巨头为何集体裁员背后的真相', duration: '22:10', views: '7.8万', tag: '分析' },
    { title: '真实记录：我在黑心培训机构当老师的180天', duration: '18:32', views: '6.5万', tag: '纪实' },
    { title: '多方求证：某热门楼盘质量问题全面调查', duration: '11:55', views: '5.2万', tag: '调查' },
  ];

  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">爆料视频</h2>
            <p className="text-sm text-foreground-500 mt-2">视听直击，还原最真实的爆料现场</p>
          </div>
          <a href="#" className="hidden sm:flex items-center text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap font-medium">
            更多视频 <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {MEDIA_ITEMS.map((item, i) => (
            <div
              key={i}
              className={`group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer ${
                i < 2 ? 'lg:col-span-1' : ''
              } ${i >= 3 ? 'sm:col-span-2 lg:col-span-1' : ''}`}
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={getMediaImage(i)}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded-md bg-foreground-900/80 text-background-50 text-[11px] font-mono backdrop-blur-sm">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-sm"></i>
                    {item.views}
                  </span>
                  <span>·</span>
                  <span>{item.duration}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}